import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import reporters from './modules/reporters'
import companies from './modules/companies'
import user from './modules/user'
import tags from './modules/tags'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    companies,
    reporters,
    tags,
  }
})